/* Cartwala Album Upload — compact mobile photo grid / visible progress / reorder. */
(() => {
  "use strict";
  const root = document.querySelector("[data-book-shop]");
  if (!root || root.dataset.cwAlbumEnhanced === "1") return;
  const editor = root.querySelector("[data-editor]");
  const uploadStage = root.querySelector('[data-stage="2"]');
  const grid = root.querySelector("[data-photo-grid]");
  const drop = root.querySelector("[data-drop]");
  const files = root.querySelector("[data-files]");
  const uploadButton = root.querySelector("[data-arrange]");
  const photoCount = root.querySelector("[data-photo-count]");
  const pageCount = root.querySelector("[data-inner-count]");
  const price = root.querySelector("[data-total]");
  const status = root.querySelector("[data-status]");
  if (!editor || !uploadStage || !grid || !drop || !files || !uploadButton || !photoCount || !pageCount || !status) return;
  root.dataset.cwAlbumEnhanced = "1";
  root.classList.add("cw-album-ui-on");

  const node = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  };
  const heading = node("div", "cw-album-upload-heading");
  const intro = node("h3", "", "Upload your photos");
  const pill = node("span", "cw-album-count-pill", "0 Photos");
  heading.append(intro, pill);
  drop.before(heading);

  const addbar = node("div", "cw-album-addbar");
  const add = node("button", "", "");
  add.type = "button";
  const plus = node("span", "", "+");
  add.append(plus, document.createTextNode("Add More Photos"));
  add.addEventListener("click", () => { if (!add.disabled) files.click(); });
  addbar.append(add);
  drop.after(addbar);

  const pageRow = node("div", "cw-album-page-strip");
  const pageIcon = node("span", "cw-album-page-icon", "▣");
  const pageInfo = node("div", "cw-album-page-info");
  const pageTitle = node("strong", "", "24 Pages");
  const pageDesc = node("small", "", "");
  pageInfo.append(pageTitle, pageDesc);
  const extraInfo = node("div", "cw-album-page-extra");
  const extraTitle = node("b", "", "+0");
  const extraDesc = node("small", "", "Pages");
  extraInfo.append(extraTitle, extraDesc);
  const cost = node("span", "cw-album-page-price", "");
  pageRow.append(pageIcon, pageInfo, extraInfo, cost);
  grid.before(pageRow);

  const overlay = node("div", "cw-album-upload-overlay");
  overlay.hidden = true;
  overlay.setAttribute("role", "status");
  overlay.setAttribute("aria-live", "polite");
  const overlayCard = node("div", "cw-album-loading-card");
  const spinner = node("div", "cw-album-loader");
  spinner.setAttribute("aria-hidden", "true");
  const loadingTitle = node("strong", "", "Adding your photos...");
  const loadingText = node("p", "", "This may take a few moments for lots of photos.");
  const loadingTrack = node("div", "cw-album-loading-track");
  const loadingBar = node("i");
  loadingTrack.append(loadingBar);
  const cancel = node("button", "", "Cancel");
  cancel.type = "button";
  cancel.setAttribute("data-cw-album-cancel", "");
  cancel.addEventListener("click", () => {
    if (typeof window.__cartwalaCancelAlbumUpload === "function") {
      window.__cartwalaCancelAlbumUpload();
      cancel.disabled = true;
      loadingTitle.textContent = "Stopping upload...";
      loadingText.textContent = "Photos already added will be kept.";
    }
  });
  overlayCard.append(spinner, loadingTitle, loadingText, loadingTrack, cancel);
  overlay.append(overlayCard);
  uploadStage.append(overlay);

  function countOf(element) {
    const m = String(element?.textContent || "").match(/\d+/);
    return m ? Number(m[0]) : 0;
  }
  function refresh() {
    const count = countOf(photoCount);
    const pages = countOf(pageCount) || 24;
    const extra = Math.max(0, pages - 24);
    pill.textContent = count + (count === 1 ? " Photo" : " Photos");
    pageTitle.textContent = pages + " Pages";
    pageDesc.textContent = count + " photos, " + extra + " extra pages";
    extraTitle.textContent = "+" + extra;
    cost.textContent = price ? price.textContent.trim() : "";
    const hasPhotos = count > 0;
    root.classList.toggle("cw-album-has-photos", hasPhotos);
    addbar.hidden = !hasPhotos;
    pageRow.hidden = !hasPhotos;
    add.disabled = editor.getAttribute("aria-busy") === "true";
    uploadButton.textContent = "Auto Design my book →";
  }
  function startLoading(count) {
    if (!count) return;
    root.classList.add("cw-album-upload-active");
    cancel.disabled = false;
    overlay.hidden = false;
    loadingTitle.textContent = "Adding your photos...";
    loadingText.textContent = "This takes a few seconds with lots of photos.";
    loadingBar.style.width = "0%";
  }
  function updateProgress() {
    const message = status.textContent || "";
    const m = message.match(/(\d+)\s*\/\s*(\d+)/);
    if (!m || overlay.hidden) return;
    const current = Number(m[1]), total = Number(m[2]);
    if (!total) return;
    loadingText.textContent = "Adding photo " + current + " of " + total;
    loadingBar.style.width = Math.min(100, Math.max(0, (current - 1) / total * 100)) + "%";
  }
  function reorder(from, to) {
    if (editor.getAttribute("aria-busy") === "true") return;
    if (!Number.isInteger(from) || !Number.isInteger(to) || to < 0 || to >= grid.children.length || from === to) return;
    const step = to > from ? 1 : -1;
    for (let i = from; i !== to; i += step) {
      const card = grid.children[i];
      const controls = card?.querySelectorAll("div button");
      const control = controls?.[step > 0 ? 3 : 2];
      if (!control || control.disabled) break;
      control.click();
    }
  }
  function enhanceGrid() {
    Array.from(grid.querySelectorAll(":scope > .cwb-photo-card")).forEach((card, index) => {
      if (card.dataset.cwAlbumCard === "1") return;
      card.dataset.cwAlbumCard = "1";
      const photo = card.querySelector("img");
      if (photo) {
        photo.title = "Tap to edit this photo";
        photo.loading = "lazy";
      }
      const buttons = card.querySelectorAll("div button");
      if (buttons.length >= 4) {
        buttons[0].setAttribute("aria-label", "Edit photo " + (index + 1));
        buttons[1].textContent = "×";
        buttons[1].setAttribute("aria-label", "Remove photo " + (index + 1));
      }
      const check = node("span", "cw-album-check", "✓");
      check.setAttribute("aria-label", "Photo selected");
      const badge = node("span", "cw-album-order", String(index + 1));
      const grip = node("button", "cw-album-grip", "⤧");
      grip.type = "button";
      grip.setAttribute("aria-label", "Drag to reorder photo " + (index + 1));
      grip.title = "Drag to reorder";
      let startPointer = null;
      grip.addEventListener("pointerdown", event => {
        if (event.pointerType === "mouse" && event.button !== 0) return;
        if (editor.getAttribute("aria-busy") === "true") return;
        event.preventDefault();
        event.stopPropagation();
        startPointer = { id: event.pointerId, x: event.clientX, y: event.clientY };
        try { grip.setPointerCapture(event.pointerId); } catch (error) {}
        card.classList.add("cw-album-dragging");
      });
      grip.addEventListener("pointerup", event => {
        if (!startPointer || startPointer.id !== event.pointerId) return;
        const target = document.elementFromPoint(event.clientX, event.clientY)?.closest(".cwb-photo-card");
        card.classList.remove("cw-album-dragging");
        const from = Array.prototype.indexOf.call(grid.children, card);
        const to = Array.prototype.indexOf.call(grid.children, target);
        startPointer = null;
        if (from >= 0 && to >= 0 && from !== to) reorder(from, to);
      });
      grip.addEventListener("pointercancel", () => {
        startPointer = null;
        card.classList.remove("cw-album-dragging");
      });
      grip.addEventListener("keydown", event => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        const from = Array.prototype.indexOf.call(grid.children, card);
        const to = from + (event.key === "ArrowRight" ? 1 : -1);
        reorder(from, to);
        requestAnimationFrame(() => grid.querySelectorAll(".cw-album-grip")[to]?.focus());
      });
      card.append(check, badge, grip);
    });
  }
  files.addEventListener("change", event => {
    if (event.target.files?.length) startLoading(event.target.files.length);
  }, true);
  drop.addEventListener("drop", event => {
    if (event.dataTransfer?.files?.length) startLoading(event.dataTransfer.files.length);
  }, true);
  const busyWatch = new MutationObserver(() => {
    if (editor.getAttribute("aria-busy") !== "true") {
      root.classList.remove("cw-album-upload-active");
      overlay.hidden = true;
      cancel.disabled = false;
    }
    refresh();
  });
  busyWatch.observe(editor, { attributes: true, attributeFilter: ["aria-busy"] });
  new MutationObserver(() => { enhanceGrid(); refresh(); }).observe(grid, { childList: true });
  new MutationObserver(refresh).observe(photoCount, { childList: true, characterData: true, subtree: true });
  new MutationObserver(refresh).observe(pageCount, { childList: true, characterData: true, subtree: true });
  if (price) new MutationObserver(refresh).observe(price, { childList: true, characterData: true, subtree: true });
  new MutationObserver(updateProgress).observe(status, { childList: true, characterData: true, subtree: true });
  root.addEventListener("click", event => {
    if (event.target.closest("[data-plan-next],[data-stage-link],[data-wizard-back],[data-start]")) {
      requestAnimationFrame(refresh);
    }
  }, true);
  enhanceGrid();
  refresh();
})();
